<template>
	<div class="relative w-full pt-5 px-5 bg-white rounded-lg mb-5 shadow-xl overflow-hidden">
		<card :trip="trip" />
	</div>
</template>

<script>
import PastTripDetails from '../components/PastTripDetails.vue';

export default {
	name: 'PastTripCard',
	props: ['trip'],
	components: {
		'card': PastTripDetails
	},
	data() {
		return {
			user: {}
		}
	},
	created() {
		this.user = this.$parent.user;
	}
}
</script>